module.exports = __webpack_public_path__ + "static/media/tablet_screen11.9d445f0e.png";